import CareDrawer from "assets/CareDrawer-min.png";
import CareEvent from "assets/CareEvent-min.png";
import CareEvent2 from "assets/CareEvent2-min.png";
import CareEvent3 from "assets/CareEvent3-min.png";
import CareEvent4 from "assets/CareEvent4-min.png";
import CareEvent5 from "assets/CareEvent5-min.png";
import CareHospital from "assets/CareHostpital-min.png";
import CareLogin from "assets/CareLogin-min.png";
import CareMsg from "assets/CareMsg-min.png";
import LineosoftBackground from "assets/contactImage.jpg";
import Mosaic1 from 'assets/Mosaic1-min.jpg';
import Mosaic2 from 'assets/Mosaic2-min.jpg';
import Mosaic3 from 'assets/Mosaic3-min.png';
import SpeedBump from 'assets/SpeedBumpCropped.jpg';
import backgroundSprPlaceholder from 'assets/spr-background-placeholder.jpg';
import imageSprLessonBuilderDarkPlaceholder from 'assets/spr-lesson-builder-dark-placeholder.jpg';
import imageSprLessonBuilderLightPlaceholder from 'assets/spr-lesson-builder-light-placeholder.jpg';
import RecipeTN from 'assets/tunisianrecipes.jpg';
import volkiharSlidePlaceholder from 'assets/volkihar-slide-placeholder.jpg';
import WadappLogin from 'assets/wadapp-min.png';
import WadappForm from 'assets/wadapp2-min.png';
import WadappList from 'assets/wadapp4-min.png';
import Footer from 'components/Footer';
import {
  ProjectBackground, ProjectContainer, ProjectHeader, ProjectImage, ProjectSection,
  ProjectSectionContent,
  ProjectTextRow
} from 'components/ProjectLayout';
import SegmentedControl, { SegmentedControlOption } from 'components/SegmentedControl';
import { useTheme } from 'components/ThemeProvider';
import { useAppContext, useScrollRestore } from 'hooks';
import { Fragment, lazy, Suspense, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import prerender from 'utils/prerender';
import { media } from 'utils/style';
import './index.css';



const title = 'Mobile Projects';
const description =
  'Overview of my personal and professionals mobile applications';

const ProjectSPR = () => {
  const Carousel = lazy(() => import('components/Carousel'));
  const { themeId } = useTheme();
  const { dispatch } = useAppContext();
  useScrollRestore();

  const isDark = themeId === 'dark';
  const themes = ['dark', 'light'];

  const handleThemeChange = index => {
    dispatch({ type: 'setTheme', value: themes[index] });
  };

  return (

    <Fragment>
      <ProjectContainer className="spr">
        <Helmet>
          <title>{`Projects | ${title}`}</title>
          <meta name="description" content={description} />
        </Helmet>
        <ProjectBackground
          opacity={isDark ? 0.5 : 0.8}
          srcSet={`${LineosoftBackground} 1080w, ${LineosoftBackground} 2160w`}
          placeholder={backgroundSprPlaceholder}
          entered={!prerender}
        />
        <ProjectHeader
          title="Careways"
          description={"Careways is a medical tourism application developed in android and IOS. It proposes a solution for patients and hospitals by allowing patients to take part in a whole process from booking treatments to sharing medical records and live chat with hospitals staffs. It enables online consultations with doctors and allows nurses to manage hospital events."}
          // url="http://196.179.226.74:8995/#/login"
          roles={["React Native", "Redux", "NodeJs", "MongoDB"]}
        />
        {/* first props for enabling class => padding-bottom: 0; */}
        <ProjectSection first>
          <ProjectSectionContent className="volkihar__carousel">
            <Suspense fallback={null}>
              <Carousel
                placeholder={volkiharSlidePlaceholder}
                images={useMemo(
                  () => [
                    {
                      src: CareLogin,
                      srcSet: `${CareLogin} 960w, ${CareLogin} 1920w`,
                      alt: 'Lineosoft React.js Dashboard',
                    },
                    {
                      src: CareDrawer,
                      srcSet: `${CareDrawer} 960w, ${CareDrawer} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareMsg,
                      srcSet: `${CareMsg} 960w, ${CareMsg} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareHospital,
                      srcSet: `${CareHospital} 960w, ${CareHospital} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent,
                      srcSet: `${CareEvent} 960w, ${CareEvent} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent5,
                      srcSet: `${CareEvent5} 960w, ${CareEvent5} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent4,
                      srcSet: `${CareEvent4} 960w, ${CareEvent4} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent3,
                      srcSet: `${CareEvent3} 960w, ${CareEvent3} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent4,
                      srcSet: `${CareEvent4} 960w, ${CareEvent4} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: CareEvent2,
                      srcSet: `${CareEvent2} 960w, ${CareEvent2} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },

                  ],
                  []
                )}
                width={432} // 432* 2.5 = 1080 real size 
                height={768} // 768 * 2.5 = 1920 real size
              />
            </Suspense>
          </ProjectSectionContent>
        </ProjectSection>


        <ProjectHeader
          title="Wadapp"
          description="The mobile version of the service management software GLPI for managing and tracking Wevioo employees requests"
          url="https://play.google.com/store/apps/details?id=io.wadapp.starter"
          roles={["Ionic", "TypeScript", "NestJS"]}
        />
        <ProjectSection >
          <ProjectSectionContent className="volkihar__carousel">
            <Suspense fallback={null}>
              <Carousel
                placeholder={volkiharSlidePlaceholder}
                images={useMemo(
                  () => [
                    {
                      src: WadappLogin,
                      srcSet: `${WadappLogin} 960w, ${WadappLogin} 1920w`,
                      alt: 'Lineosoft React.js Dashboard',
                    },
                    {
                      src: WadappList,
                      srcSet: `${WadappList} 960w, ${WadappList} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: WadappForm,
                      srcSet: `${WadappForm} 960w, ${WadappForm} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                  ],
                  []
                )}
                width={545 *0.79} // 432* 2.5 = 1080 real size 
                height={969*0.79} // 768 * 2.5 = 1920 real size
              />
            </Suspense>
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="Mosaic"
          description="Mosaic in mobile application for displaying the historical mosaic painting and playing the podcast behind.
          Users can download low quality media to use the app offline, customize app theme and font, change content language.
         Mosaic app enables also saving favorite section, custom comment and notification reminder.
         The application content is managed through a ReactJs admin dashboard, in which section can be reordered and media are inserted in high and low quality.
          "
          // url="https://sodebs.netlify.app/"
          roles={["React Native", "Redux", "Realm", "ReactJs", "Laravel"]}
        // roles={roles}
        />
        <ProjectSection  >
          <ProjectSectionContent className="volkihar__carousel">
            <Suspense fallback={null}>
              <Carousel
                placeholder={volkiharSlidePlaceholder}
                images={useMemo(
                  () => [
                    {
                      src: Mosaic1,
                      srcSet: `${Mosaic1} 960w, ${Mosaic1} 1920w`,
                      alt: 'Lineosoft React.js Dashboard',
                    },
                    {
                      src: Mosaic2,
                      srcSet: `${Mosaic2} 960w, ${Mosaic2} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: Mosaic3,
                      srcSet: `${Mosaic3} 960w, ${Mosaic3} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                  ],
                  []
                )}
                width={432} // 432* 2.5 = 1080 real size 
                height={768} // 768 * 2.5 = 1920 real size
              />
            </Suspense>
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="Recette Tunisienne"
          description="Android application for cooking Tunisian recipes.
          This application is developed in Evertek Android App challenge in 2016."
          url="https://apkpure.com/fr/recette-tunisienne/com.jarraya.mehdi.plattunisienne"
          roles={["Android", "Parse"]}
        // roles={roles}
        />
        <ProjectSection >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? RecipeTN : RecipeTN
                } 1280w, ${isDark ? RecipeTN : RecipeTN
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="Speed bump in Tunisia"
          description="Android and IOS application to alert users from the closest speed bumps.
          Speed bumps are reported by user photo or by the phone accelerometer sensor.
          User notification will appear to confirm the reported speed bump.
          "
          url="https://appadvice.com/app/dos-dane-tunisie/1080214242"
          roles={["Android", "iOS", "Parse"]}
        />
        <ProjectSection >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? SpeedBump : SpeedBump
                } 1280w, ${isDark ? SpeedBump : SpeedBump
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
            <ProjectTextRow>
              <SegmentedControl
                currentIndex={themes.indexOf(themeId)}
                onChange={handleThemeChange}
              >
                <SegmentedControlOption>Dark theme</SegmentedControlOption>
                <SegmentedControlOption>Light theme</SegmentedControlOption>
              </SegmentedControl>
            </ProjectTextRow>
          </ProjectSectionContent>
        </ProjectSection>
      </ProjectContainer>
      <Footer />
    </Fragment>
  );
};

export default ProjectSPR;
